export const DOWNLOAD_APP_POPUP_TIMEOUT = 1000;

export const APP_STORES_LINKS = {
  APP_STORE_DOWNLOAD_URL:
    "https://apps.apple.com/us/app/h%C3%A6rvejen/id1318734385",
  GOOGLE_PLAY_DOWNLOAD_URL:
    "https://play.google.com/store/apps/details?id=dk.haervejen.app",
};
